import TodoList from "../../components/TodoList";

// An employee's personal todo list. Items an admin assigned show an
// "Assigned by …" chip (handled inside TodoList).
export default function MyTodosPage() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">My Todos</h1>
          <div className="page-sub">Your personal checklist</div>
        </div>
      </div>

      <TodoList params={{}} createExtra={{}} />
    </>
  );
}
